module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-locked-2cd937adf3046894dd9e3debef0a2b38.svg";